import React from 'react';
import { Card } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SearchFields from './searchFields';

const useStyles = makeStyles(() => ({
  searchbar: {
    width: '100%',
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    background: '#29307E',
    color: 'white',
  },
}));

function SearchBar() {
  const classes = useStyles();

  return (
    <Card className={classes.searchbar}>
      <SearchFields />
    </Card>
  );
}

export default SearchBar;
